import { createElement } from "react";
import React from "react";
import { createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Button_pillButton, Dialog_Dialog } from "./Components/Components.js";
import { useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import react_apple_login from "react-apple-login";
import { OAuthTarget, OAuthRegister, handleGoogleToken, handleAppleToken } from "./Components/OAuth.js";
import { GoogleLogin } from "@react-oauth/google";
import { some } from "./fable_modules/fable-library-js.4.17.0/Option.js";

function drawBanned(until, banReason) {
    let elems_2;
    return createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        maxWidth: 500,
        padding: 5,
        display: "flex",
        flexDirection: "column",
        gap: ((10 + "px ") + 0) + "px",
    }], (elems_2 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            padding: 5,
            textAlign: "center",
            borderRadius: 5,
            color: "var(--sell)",
            fontWeight: "bold",
        }], (elems = [createElement("span", {
            children: ["Denne brukeren er utestengt fra aksje.io."],
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue, u, elems_1;
            return append((matchValue = until, (matchValue != null) ? ((u = matchValue, singleton(createElement("div", createObj(ofArray([["style", {
                textAlign: "center",
                color: "var(--text-main)",
            }], (elems_1 = [createElement("span", {
                children: [u],
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))))) : (empty())), delay(() => singleton(createElement("p", {
                style: {
                    marginTop: 10,
                    textAlign: "center",
                },
                children: banReason,
            }))));
        }));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
}

function wrapDialog(children) {
    return createElement(Dialog_Dialog, {
        onClose: () => {
        },
        children: singleton_1(children),
    });
}

export function Signup() {
    let elems_11;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(undefined);
    const setBanned = patternInput_2[1];
    const banned = patternInput_2[0];
    const setErrMsg = useFeliz_React__React_useState_Static_1505(undefined)[1];
    const domain = window.location.host;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        backgroundColor: "var(--bg-dark)",
    }], (elems_11 = toList(delay(() => {
        let elems;
        if (banned == null) {
            const matchValue = patternInput[0];
            if (matchValue == null) {
                const matchValue_1 = patternInput_1[0];
                if (matchValue_1 == null) {
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#FFFFFF",
                        textAlign: "center",
                    }], (elems = [createElement("span", {
                        style: {
                            fontWeight: "bold",
                            fontSize: 1.5 + "rem",
                            marginTop: 2 + "rem",
                        },
                        children: "Registrer deg på aksje.io",
                    }), createElement("span", {
                        children: "Bli med gratis og hold deg oppdatert på dine favorittaksjer!",
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                        let elems_10, elems_4, elems_3, elems_5, elems_6, elems_9, elems_7, elems_8;
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }], (elems_10 = [createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            margin: 30,
                            gap: ((20 + "px ") + 0) + "px",
                            height: 110,
                            width: 290,
                        }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                            padding: 2,
                        }], (elems_3 = [Interop_reactApi_1.createElement(react_apple_login, {
                            clientId: "io.aksje.www",
                            redirectURI: `https://${domain}/apple-auth`,
                            usePopup: true,
                            callback: (res) => {
                                handleAppleToken(res, (tokenResult) => {
                                    switch (tokenResult.tag) {
                                        case 1: {
                                            setErrMsg(tokenResult.fields[0]);
                                            break;
                                        }
                                        case 2: {
                                            setBanned([tokenResult.fields[0], tokenResult.fields[1]]);
                                            break;
                                        }
                                        default:
                                            patternInput_1[1](tokenResult.fields[0]);
                                    }
                                });
                            },
                            scope: "email",
                            responseMode: "query",
                            render: (renderProps) => {
                                let elems_2, elems_1;
                                return createElement("button", createObj(ofArray([["onClick", (_arg) => {
                                    renderProps.onClick();
                                }], ["style", {
                                    backgroundColor: "white",
                                    color: "#202124",
                                    fontSize: 15 + "px",
                                    minWidth: 190,
                                    maxWidth: 400,
                                    borderRadius: 25,
                                    height: 40,
                                    cursor: "pointer",
                                }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                                    gap: ((0 + "px ") + 5) + "px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                    padding: ((0 + "px ") + 5) + "px",
                                }], (elems_1 = [createElement("i", {
                                    style: {
                                        fontSize: 25 + "px",
                                    },
                                    className: "fab fa-apple px-2",
                                }), "Logg inn med Apple"], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
                            },
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]))), Interop_reactApi_1.createElement(GoogleLogin, {
                            size: "large",
                            shape: "pill",
                            theme: "filled_white",
                            onSuccess: (x_10) => {
                                handleGoogleToken(x_10.credential, (tokenResult_1) => {
                                    switch (tokenResult_1.tag) {
                                        case 1: {
                                            setErrMsg(tokenResult_1.fields[0]);
                                            break;
                                        }
                                        case 2: {
                                            setBanned([tokenResult_1.fields[0], tokenResult_1.fields[1]]);
                                            break;
                                        }
                                        default:
                                            patternInput[1](tokenResult_1.fields[0]);
                                    }
                                });
                            },
                            onError: (x_12) => {
                                console.log(some(`onError: ${x_12}`));
                            },
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["className", "or-tall"], (elems_5 = [createElement("div", {
                            style: {
                                height: 20,
                                width: 2,
                                backgroundColor: "#FFFFFF",
                            },
                        }), createElement("span", {
                            style: {
                                color: "#FFFFFF",
                                fontSize: 15 + "px",
                                fontStyle: "italic",
                            },
                            children: "eller",
                        }), createElement("div", {
                            style: {
                                height: 20,
                                width: 2,
                                backgroundColor: "#FFFFFF",
                            },
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["className", "or-wide"], (elems_6 = [createElement("div", {
                            style: {
                                height: 2,
                                width: 20,
                                backgroundColor: "#FFFFFF",
                            },
                        }), createElement("span", {
                            style: {
                                color: "#FFFFFF",
                                fontSize: 15 + "px",
                                fontStyle: "italic",
                            },
                            children: "eller",
                        }), createElement("div", {
                            style: {
                                height: 2,
                                width: 20,
                                backgroundColor: "#FFFFFF",
                            },
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {
                            margin: 30,
                            display: "flex",
                            flexDirection: "column",
                            height: 110,
                            width: 290,
                            justifyContent: "space-between",
                        }], (elems_9 = [createElement("a", createObj(ofArray([["href", "/register"], ["style", {
                            textAlign: "center",
                        }], (elems_7 = [Button_pillButton("Registrer med e-post", (_arg_1) => {
                        }, ofArray([["paddingTop", 13], ["paddingBottom", 13], ["backgroundColor", "#FFFFFF"], ["border", "none"], ["color", "var(--text-main)"], ["fontSize", 1 + "rem"]]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", {
                            textAlign: "center",
                            color: "var(--text-dimmer)",
                            height: 32,
                            fontSize: 15 + "px",
                        }], (elems_8 = [createElement("span", {
                            children: ["Allerede registrert?"],
                        }), createElement("a", {
                            style: {
                                textDecoration: "underline",
                                marginLeft: 10,
                                color: "#FFFFFF",
                            },
                            href: "/sign-in",
                            children: "Logg inn",
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])]))));
                    }));
                }
                else {
                    const arf = matchValue_1;
                    return singleton(wrapDialog(createElement(OAuthRegister, {
                        target: new OAuthTarget(1, [arf]),
                    })));
                }
            }
            else {
                const grf = matchValue;
                return singleton(wrapDialog(createElement(OAuthRegister, {
                    target: new OAuthTarget(0, [grf]),
                })));
            }
        }
        else {
            return singleton(drawBanned(banned[0], banned[1]));
        }
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))])])));
}

